export default "__VITE_ASSET__CLdCCshx__"